import { Endpoints } from "~constants/endpoints"
import { Api } from "~utils/api"
import { AxiosResponse } from "axios"
import { Broker } from "~shapes/portfolio"

export const BrokerService = {
  getUserBrokerConnectionsV3: async (userId: string): Promise<Broker[]> => {
    const userBrokerUrl = `${Endpoints.BROKER_CONNECTIONS_V3.URL}?user_id=${userId}`
    try {
      const response: AxiosResponse = await Api.get(userBrokerUrl, {
        headers: {
          "Cache-Control": "no-cache",
        },
      })
      return response?.data?.data
    } catch (error) {
      return Promise.reject(error)
    }
  },

  disconnectUserFromBrokers: async (userId: string, connectionId?: string) => {
    let deleteUrl = Endpoints.USER_BROKERS.URL.replace(":userId", userId)
    if (!!connectionId) {
      deleteUrl = Endpoints.BROKER_CONNECTIONS_V2.URL.concat("/", connectionId)
    }
    try {
      return await Api.delete(deleteUrl)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
